<swiper
  [config]="config"
  #swiperSlideShow
  class="height-100"
  (slideChange)="onSlideChange($event)"
>
  <ng-template swiperSlide *ngFor="let adBanner of adBanners; let i = index">
    <div class="img-container d-flex justify-content-center">
      <img
        src="{{ adBanner.imageUrl }}"
        alt="{{ adBanner.label }}"
        (click)="navigateToProduct(adBanner.url)"
        loading="eager"
      />
    </div>
  </ng-template>
</swiper>
